import { Injectable, Injector } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { WatchListModel } from "./gotx/pages/WatchList/WatchList.model";
import { DropDown } from "./DropDownOptions";
import { KeyConstants } from "./constants.model";

@Injectable()
export class Data {
    private notificationService: any;
    dtFromDateString: any;
    dtToDateString(arg0: any): any {
        throw new Error('Method not implemented.');
    }
    dateFromDateString(arg0: any): any {
        throw new Error('Method not implemented.');
    }
    dtTodateString(arg0: any): any {
        throw new Error('Method not implemented.');
    }
    private messageSource2 = new Subject<string>();
    message$ = this.messageSource2.asObservable();
    exchProduct: any;
    productDerivative: any;
    productSourceGlobal: any;
    exchangeData: any;
    exchangeList: any[] = [];
    stockMaster: any;
    stockMasterMap = new Map();
    //watchListMap = new Map();
    watchListMap:Map<string,any> =new Map<string,any>();
    investorList: any;
    stockInWatchlist: any = [];
    participantIDList: any;
    marginGroupList: any;
    indxList = ["CSE30", "CSCX"];
    subbedStocks = [];
    board:String;
    Chart:String;
    productList: any;
    dervProductList:any;



    private mapData = new Map();
    private _inputdata: any;
    internalMap: any;

    setData(key, value) {
        this.mapData.set(key, value);
    }
    getData(key) {
        return this.mapData.get(key);
    }

    constructor(private watchlistModel: WatchListModel, private injector: Injector) { }

    // populate dropdown options
    loadDropdown(pageNo: number, searchTerm: any, pageCount: number, filterJson: any, fieldID: string) {
        switch (fieldID) {
            case "cmbExchange": {
                return this.getcmbExchange();
                break;
            }
            case "cmbProduct": {
                return this.getcmbProduct();
                break;
            }
            case "cmbMargin": {
                return this.getcmbMargin();
                break;
            }
            case "cmbProductderivative": {
                return this.getcmbProductderivative();
                break;
            }
            case "cmbBoard": {
                return this.getcmbBoard();
                break;
            }
            case "cmbStatus": {
                return this.getcmbStatus();
                break;
            }
            case "cmbAction": {
                return this.getcmbAction();
                break;
            } case "cmbCurrency": {
                return this.getcmbCurrency();
                break;
            } case "cmbInvestorId": {
                return this.getcmbInvestorList();
                break;
            } case "cmbOrderType": {
                return this.getcmbOrderType();
                break;
            } case "cmbFillType": {
                return this.getcmbFillType();
                break;
            } case "cmbAnnouncementId": {
                return this.getAnnouncementId();
                break;
            }
            case "cmbChart": {
                return this.getAnnouncementId();
                break;
            }
            case "cmbMtasChart": {
                return this.getChartList();
                break;
            }
            case "cmbMtasStrokeSize": {
                return this.getStrokeList();
                break;
            }
            case "cmbMtasStrokeDash": {
                return this.getStrokeDash();
                break;
            }
            case "cmbMtasMarkerSize": {
                return this.getMarkerSize();
                break;
            }
            case "cmbMtasMarkerType": {
                return this.getMarkerType();
                break;
            }
            case "cmbMtasDrawTool": {
                return this.getDrawTool();
                break;
            }
            case "cmbMtasFontSize": {
                return this.getFontSize();
                break;
            }
            case "cmbTheme": {
                return this.getThemes();
                break;
            }
            case "cmbLanguage": {
                return this.getLanguages();
                break;
            }
        }
    }

    delWatchlist(message: string) {
      this.messageSource2.next(message);
    }

    getAnnouncementId() {
        var action = [{ id: 1, text: "Markets" }];
        if (this.participantIDList != null && this.participantIDList != '' && this.participantIDList != undefined) {
            action.push({ id: 5, text: this.participantIDList });
        }
        return action;
    }

    clearLoginNotifications() {
  if (!this.notificationService) {
    const { NotificationService } = require('./notification.service');
    this.notificationService = this.injector.get(NotificationService);
  }

  if (this.notificationService && this.notificationService.clearNotifications) {
    this.notificationService.clearNotifications();
    console.log(" Notifications cleared via DataService");
  }
}

    clearAll() {
        this.clearLoginNotifications();
  console.log("All data and notifications cleared");
        this.mapData = new Map();
        this.setExchProduct([]);
        this.setProductDerivative([]);
        this.setExchangeData([]);
        this.setStockMaster([]);
        this.setInvestorList([]);
        this.setParticipantIDList([]);
        this.setmarginGroupList([]);
        this.watchListMap.clear();
        this.watchlistModel.clearWatchlist();
        this.stockMasterMap.clear();
        this.indxList = [];
        this.exchangeList = [];

        localStorage.removeItem('userID');
    }

    getcmbAction() {
        var action = [{ id: "BUY", text: "BUY" }, { id: "SELL", text: "SELL" }]
        return action;
    }

    getcmbExchange() {
        return this.exchangeList;
    }

    getExchByDispExch(dispExch: string) {
        let exch = this.exchangeData.filter(el => el.dispExch == dispExch).map(el => el.exch)[0];
        return exch;
    }

    getDispExch(exch: string) {
        let dispExch = this.exchangeList.filter(el => el.id == exch).map(el => el.text)[0];
        return dispExch;
    }

    getcmbInvestorList() {
        var invList = [];
        this.investorList.forEach(element => {
            invList.push({ id: element, text: element });
        });
        return invList;
    }

    getcmbProduct() {
        var product = [];
        let exch = this.getData("exchangeID");
        for (var key in this.exchProduct[exch]) {
            let item = this.exchProduct[exch][key];
            product.push({ id: item, text: item });
        }
        this.productList = product;
        console.log("this.productList",this.productList);
        return product;
    }
    getcmbProductderivative(){
        var product = [];
        for (var key in this.productDerivative) {
            let item = this.productDerivative[key];
            product.push({ id: item, text: item });
        }
        this.dervProductList = product;
        console.log("this.DervproductList",this.dervProductList);
        return product;

    }
    getcmbMargin() {
        var margin = [];
        for (var key in this.marginGroupList) {
            let item = this.marginGroupList;
            margin.push({ id: item[key].marginGroupNo, text: item[key].marginGroupName });
        }
        return margin;
    }

    getProductByExch(exch, prodOptions: DropDown, placeholder) {
        var product = [];
        for (var key in this.exchProduct[exch]) {
            let item = this.exchProduct[exch][key];
            product.push({ id: item, text: item });
        }

        prodOptions.Options = [{ id: undefined, text: placeholder }];
        prodOptions.Options = prodOptions.Options.concat(product);

        return prodOptions.Options;
    }
    

    getCustomWatchlistMap(selectedWatchlist :string) :any[] {
        const CustomWatchlistMap = this.watchListMap.get(selectedWatchlist);
        return CustomWatchlistMap ?[...CustomWatchlistMap]:[];
    }

    getcmbStatus() {
        var stat = [{ id: "ACTIVEORDERS", text: "Active Orders" }, { id: "FULLYEXECUTED", text: "Fully Executed" }, { id: "REJECTEDCANCELLED", text: "Rejected & Cancel" },
        { id: "TRADEDORDERS", text: "Traded Orders" }, { id: "ALL", text: "ALL" }]
        return stat;
    }

    getcmbCurrency() {
        var currency = [{ id: "BDT", text: "BDT" }]
        return currency;
    }
    getcmbOrderType() {
        var orderType = [{ id: "LIMIT", text: "Limit" }, { id: "MARKET", text: "Market" }, { id: "STOPLIMIT", text: "Stop Limit" }, { id: "STOPMARKET", text: "Stop Market" }];
        return orderType;
    }
    getcmbFillType() {
        var fillType = [{ id: "GFD", text: "GFD" }, { id: "GTD", text: "GTD" }, { id: "GTC", text: "GTC" }, { id: "ATO", text: "ATO" }, { id: "ATC", text: "ATC" }];
        return fillType;
    }
    
    getFillType(board, orderType,product) {
        console.log("Product inside filletype",product,"orderType",orderType);
        if (orderType == "LIMIT") {
	    if(product == "EQUITY" || product == "DEBT"){	
		var fillType = [{ id: "GFD", text: "GFD" }, { id: "GTD", text: "GTD" }, { id: "GTC", text: "GTC" }, { id: "ATO", text: "ATO" }, { id: "ATC", text: "ATC" }];
	    }else{
                fillType = [{ id: "GFD", text: "GFD" }, { id: "GTD", text: "GTD" }, { id: "GTC", text: "GTC" }, { id: "ATO", text: "ATO" }, { id: "ATC", text: "ATC" },{ id: "IOC", text: "IOC" }];
            }

            if (board == "SP") {
                fillType = [{ id: "GFD", text: "GFD" }]
            }
        }
        else if (orderType == "MARKET") {
	    if(product == "EQUITY" || product == "DEBT"){
                fillType = [{ id: "FOK", text: "FOK" }, { id: "PFRC", text: "PFRC" }, { id: "PFRK", text: "PFRK" }, { id: "MFL", text: "MIN FILL" }]
            }else{
                fillType = [{ id: "FOK", text: "FOK" }, { id: "PFRC", text: "PFRC" }, { id: "PFRK", text: "PFRK" }, { id: "MFL", text: "MIN FILL" },{ id: "IOC", text: "IOC" }]
            }
        }
        else if (orderType == "STOPMARKET") {
	    if(product == "EQUITY" || product == "DEBT"){
		fillType = [{ id: "FOK", text: "FOK" }, { id: "PFRK", text: "PFRK" }, { id: "MFL", text: "MIN FILL" }]
	     }else{
                fillType = [{ id: "FOK", text: "FOK" }, { id: "PFRK", text: "PFRK" }, { id: "MFL", text: "MIN FILL" },{ id: "IOC", text: "IOC" }]
            }
        }
        else if (orderType == "STOPLIMIT") {
	    if(product == "EQUITY" || product == "DEBT"){
		fillType = [{ id: "GFD", text: "GFD" }, { id: "GTD", text: "GTD" }, { id: "GTC", text: "GTC" }]
	    }else{
                fillType = [{ id: "GFD", text: "GFD" }, { id: "GTD", text: "GTD" }, { id: "GTC", text: "GTC" },{ id: "IOC", text: "IOC" }]
            }
                if (board == "SP") {
                fillType = [{ id: "GFD", text: "GFD" }]
            }
        }

        return fillType;
    }

    getcmbBoard() {
        var board = [{ id: "AL", text: "ALL" }, { id: "NR", text: "Normal" }, { id: "SP", text: "Spot" }]
        return board;
    }
    getcmbBoardDerivatives() {
        var board = [{ id: "NR", text: "Normal" }]
        return board;
    }

    getcmbChart(){
        var Chart = [{ id: "AL", text: "ALL" }, { id: "NR", text: "Normal" }, { id: "SP", text: "Spot" }]
        return Chart;
    }
    getBoardByID(boardId) {
        let boards = [{ id: "NR", text: "Normal" }, { id: "SP", text: "Spot" }, { id: "OD", text: "OdLot" }, { id: "BK", text: "Bulk" }, { id: "AU", text: "Auction" }, { id: "FR", text: "Foreign" }, { id: "AT", text: "ATB" }, { id: "SM", text: "SME" }]
        return boards.filter(el => el.id == boardId);
    }
    // getBoardByExchSymbol(exchSymbol) {
    //     let stock = this.stockMaster.filter(el => el.exchSymbol == exchSymbol);
    //     return stock[0].board;
    // }
    getSymbolByExchSymbol(exchSymbol, exch, product) {
        let exchSymbolKey = exch + "#" + product + "#" + exchSymbol;
        return this.stockMasterMap.get(exchSymbolKey).symbol;
    }

    getcmbStockInput(searchMode: string, exch?: any, pdct?: any, board:any = "NR") {
        let stockSource = [];
        if (exch !== undefined && board) {         
            return this.stockMasterMap.get(exch + "#" + pdct + "#" + board + "#STOCKS");
            
        }
         else { 
            exch = this.getData("exchangeID");
            pdct = this.getData("productID");
            return this.stockMasterMap.get(exch + "#" + pdct + "#" + board + "#STOCKS");
        }
    }
    getproductMasterData(){
        var product = [];
        var productFinal = "";
        let exch = this.getData("exchangeID");
        for (var key in this.exchProduct[exch]) {
            let item = this.exchProduct[exch][key];
            product.push({ id: item, text: item });
        }
        if(product.includes("EQUITY")){
            productFinal = "EQUITY"
        }else{
            productFinal = product[0].text;
        }
        return productFinal;

    }

    getIndxList() {
        return this.indxList;
    }
    
    setExchProduct(exchProduct: any) {
        this.exchProduct = exchProduct;
       // var exchProduct;
       if(this.exchProduct.length != 0){
        console.log("this.exchProduct",this.exchProduct.length);
        this.exchProduct.CTG = this.exchProduct.CTG.filter(e => e !== "DEBT");
       }
        //this.exchProduct.CTG = this.exchProduct.CTG.filter(e => e !== "DEBT");
        
    }
    
    setProductDerivative(exchProduct: any) {
        this.productDerivative = exchProduct; 
        this.productDerivative = this.productDerivative.filter(e => e !== "DEBT");
    }
    
    //added by pooja starts
    private messageSource = new BehaviorSubject<string>('default message');
     currentMessage = this.messageSource.asObservable();
    changeMessage(message: string) {
        this.messageSource.next(message);
    }
    //added by pooja ends

   setProductSource(productSource){
        this.productSourceGlobal = productSource;

    }
    getProductSource(){
        return this.productSourceGlobal;
    }
    
    setExchangeData(exchangeData: any) {
        this.exchangeData = exchangeData;
        

        var exg = [];
        for (var key in this.exchProduct) {
            let dispExch = this.exchangeData.filter(el => el.exch == key).map(el => el.dispExch)[0];
            exg.push({ id: key, text: dispExch });
        }

        this.exchangeList = exg;
       
    }

    setInvestorList(investorList: any) {
        this.investorList = investorList;
    }
    setParticipantIDList(participantIdList: any) {
        // console.log("participantIdList+++", participantIdList);
        this.participantIDList = participantIdList;
    }
    setmarginGroupList(marginGroupList: any) {
        this.marginGroupList = marginGroupList;

    }

    getWatchList() {
        return this.watchlistModel.getWatchlist();
    }

    addWatchlist(item: string, isCustom: boolean = false, isDefault: boolean = false) {
        this.watchlistModel.addWatchlist(item, isCustom, isDefault);

    }

    removeWatchlist(delteWatchlist) {
        // let idx = this.watchlistModel.watchListOptions.indexOf(item);//   filter(el => {});
        const idx = this.watchlistModel.watchListOptions.findIndex(item => item.id === delteWatchlist);
        // console.log("Data service ", idx);
        this.watchlistModel.removeWatchlist(idx);
    }

    setWatchListMap(watchKey, stockList: any) {
        let stockKey = "";
        let watchList = [];
        stockList.forEach(el => {
            stockKey = el.Exch + "#" + el.Product + "#";
            if (el.Symbol && el.Symbol.split('__')[1] != null) {
                stockKey += el.Symbol.split('__')[1];
            } else {
                stockKey += "NR";
            }
            if (el.Symbol)
                stockKey += "#" + el.Symbol.split('__')[0];

            // console.log("setWatchListMap", watchKey, stockKey, this.stockMasterMap.has(stockKey));
            if (this.stockMasterMap.has(stockKey)) {
                watchList.push(this.stockMasterMap.get(stockKey));
            }
        });
        this.watchListMap.set(watchKey, watchList);
    }

    setStockMaster(stockMaster: any) {
        this.stockMaster = stockMaster; // List of All Stocks
        var boardKey = "";
        var stockKey = "";
        var exchStockKey = "";
        var exchSymbolKey = "";
        var allBoardKey = "";
        var stockList = [];
	var derivativeKey = "";
	const seenKeys = new Set();

	this.stockMaster = stockMaster.filter(el => {
          const key = el.exch + "#" + el.product + "#" + el.board + "#" + el.symbol;
          if (seenKeys.has(key)) return false;
          seenKeys.add(key);
          return true;
	});

        this.stockMasterMap.clear();
        this.stockMaster.forEach(el => {
            stockKey = el.exch + "#" + el.product + "#" + el.board + "#" + el.symbol;
            exchStockKey = el.exch + "#" + el.product + "#" + el.board + "#" + el.exchSymbol;
            exchSymbolKey = el.exch + "#" + el.product + "#" + el.exchSymbol;
            derivativeKey = el.exch + "#" + el.product + "#" + el.board + "#" + el.underlying;
            //derivativeKey = el.exch + "#" + el.product + "#" + el.board ;
            //console.log("stockKey--------------1",stockKey);
            //console.log("exchStockKey--------------2",exchStockKey);
            //console.log("exchSymbolKey--------------3",exchSymbolKey);
            //console.log("derivativeKey--------------3",derivativeKey);
            if (!this.stockMasterMap.has(el.symbol)) {
              this.stockMasterMap.set(stockKey, el);
            }
            if (!this.stockMasterMap.has(el.exchSymbol)) {
              this.stockMasterMap.set(exchStockKey, el);
              this.stockMasterMap.set(exchSymbolKey, el);
            }
            //if (!this.stockMasterMap.has(el.underlying)) {
              this.stockMasterMap.set(derivativeKey, el);
            //}
            //console.log("--------------5",this.stockMasterMap);

if(el.product == "EQUITY"){
    boardKey = el.exch + "#" + el.product + "#" + el.board + "#STOCKS";
}else{
    boardKey = el.exch + "#" + el.underlyingType + "#" + el.board + "#STOCKS";
}
           
            //To get Commodity stocks with board NR 
            if (this.stockMasterMap.has(boardKey)) {
                stockList = [];
                stockList = this.stockMasterMap.get(boardKey);
                //console.log("--------------6",stockList);
                stockList.push(el);
                this.stockMasterMap.set(boardKey, stockList);
            } else {
                //console.log("--------------7",[el]);
                this.stockMasterMap.set(boardKey, [el]);
            }
          //To get equity stocks with board NR and SP
            allBoardKey = el.exch + "#" + el.product + "#AL#STOCKS";

            if (this.stockMasterMap.has(allBoardKey)) {
                stockList = [];
                stockList = this.stockMasterMap.get(allBoardKey);
                stockList.push(el);
                this.stockMasterMap.set(allBoardKey, stockList);
            } else {
                this.stockMasterMap.set(allBoardKey, [el]);
            }
        });
    }
    
    setProductForDerivative(value){
        var productMap = [];
        for (var i=0; i < value.length; i++){
            productMap.push( this.convertProductMap(value[i].product));
        }
        return productMap;
    }
    
    convertProductMap(product){
       var productMapList = "";
        if(product == "EQUITY"){
            productMapList = "EQUITY";
        }else if (product == "CFT"){
            productMapList ="FUTCOM";
        }else if (product == "COT"){
            productMapList = "OPTCOM";
        }else if(product == "STF"){
            productMapList = "FUTSTK";
        }else if(product == "STO"){
            productMapList = "OPTSTK";
        }else if(product == "IDF"){
            productMapList = "FUTIDX";
        }else if(product == "IDO"){
            productMapList = "OPTIDX";
        }
        return productMapList;
    }
    serverDateStringToDate(strDate) {
        let strAr = strDate.split('-');
        var y = new Date(strAr[0], strAr[1] - 1, strAr[2]);
        return y;
    }

    dateStringToDate(strDate) {
        let strAr = strDate.split('/');
        var y = new Date(strAr[2], strAr[1] - 1, strAr[0]);
        return y;
    }

    dateToDateString(d) {
        var date = this.dateStringToDate(d);
        var x: String = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
        var month = (date.getMonth() + 1).toString();
        var dat = date.getDate() + "";
        if (date.getMonth() < 9) {
            month = "0" + month;
        }
        if (date.getDate() < 10) {
            dat = "0" + dat;
        }
        var x: String = date.getFullYear() + "-" + month + "-" + dat;
        return x;
    }

    dateConversion(dateStr) {
        if (dateStr != undefined && dateStr != null && dateStr != "" && dateStr != "0") {
            return dateStr.slice(6, 8).concat("/").concat(dateStr.slice(4, 6)).concat("/").concat(dateStr.slice(0, 4));
        } else {
            return "";
        }
    }

    dateToInt(strDate: String) {
        var result: Number = Number.parseInt(strDate.split("-").join("")); // Property 'replaceAll' does not exist on type 'String'.
        return result;
    }

    formGenericData: any;
    RefNo: any;
    draftNo: any;
    draftRemarks: any;

    private routeParams = new Map<number, Map<any, any>>();
    setRouteParams(currentLevel, routeParamsMap) {
        this.routeParams.set(currentLevel, routeParamsMap);
    }

    getRouteParam(currentLevel, key) {
        var routeParamMap = this.routeParams.get(currentLevel);
        if (routeParamMap) {
            return routeParamMap.get(key);
        }
        return undefined;
    }

    modalRefs: Map<number, any> = new Map<number, any>();
    setModalReference(currentLevel: number, modalRef) {
        this.modalRefs.set(currentLevel, modalRef);
    }

    getModalReference(level: number) {
        return this.modalRefs.get(level);
    }

    checkBreadcrumbUpdate: Subject<any> = new Subject<any>();

    updateBreadcrumb(breadcrumbData: any[]) {
        this.checkBreadcrumbUpdate.next(breadcrumbData);
    }
    // public getChartList(): any {
    //     return this.internalMap[KeyConstants.CHART_SERIES_TYPES];
    //   }
    public getChartList(): any {
        var chart = [{
            "id": "area",
            "text": "Area"
          },
          {
              "id": "candlestick",
            "text": "Candlestick"
          },
          {
              "id": "jumpLine",
            "text": "Jump Line"
          },
          {
              "id": "line",
            "text": "Line"
          },
          {
              "id": "marker",
            "text": "Marker"
          },
          {
              "id": "ohlc",
            "text": "OHLC"
          },
          {
              "id": "rangeArea",
            "text": "Range Area"
          },
          {
              "id": "rangeColumn",
            "text": "Range Column"
          },
          {
              "id": "rangeSplineArea",
            "text": "Range Spline Area"
          },
          {
              "id": "rangeStepArea",
            "text": "Range Step Area"
          },
          {
              "id": "spline",
            "text": "Spline"
          },
          {
              "id": "splineArea",
            "text": "Spline Area"
          },
          {
              "id": "stepArea",
            "text": "Step Area"
          },
          {
              "id": "stepLine",
            "text": "Step Line"
          },
          {
              "id": "stick",
            "text": "Stick"
          },
          {
              "id": "Renko",
            "text": "Renko"
          }];
        
        return chart;
    }
    public getStrokeList(): any {
        var item = [{
            "id": "1",
            "text": "1 px"
            },
            {
            "id": "2",
            "text": "2 px"
            },
            {
            "id": "3",
            "text": "3 px"
            },
            {
            "id": "4",
            "text": "4 px"
            },
            {
            "id": "5",
            "text": "5 px"
            },
        ];
        return item;
    }
    public getStrokeDash(): any {
        var item = [{
            "id": "6",
            "text": "solid"
            },
            {
            "id": "7",
            "text": "dotted"
            },
            {
            "id": "8",
            "text": "dashed"
            }
        ];
        return item;
    }
    public getMarkerSize(): any {
        var item = [{
            "id": "5",
            "text": "5 px"
            },
            {
            "id": "10",
            "text": "10 px"
            },
            {
            "id": "15",
            "text": "15 px"
            },
            {
            "id": "20",
            "text": "20 px"
            },
            {
            "id": "25",
            "text": "25 px"
            },
        ];
        return item;
    }
    public getMarkerType(): any {
        var item = [{
            "id": "arrowUp",
            "text": "Up Arrow"
            },
	        {
            "id": "arrowDown",
            "text": "Down Arrow"
            },
	        {
            "id": "arrowLeft",
            "text": "Left Arrow"
            },
	        {
            "id": "arrowRight",
            "text": "Right Arrow"
            },
	        {
            "id": "arrowHead",
            "text": "Head Arrow"
            },	    
	        {
            "id": "cross",
            "text": "Cross"
            },
	        {
            "id": "diagonalCross",
            "text": "Diagonal cross"
            },
	        {
            "id": "diamond",
            "text": "Diamond"
            },
	        {
            "id": "pentagon",
            "text": "Pentagon"
            },
	        {
            "id": "square",
            "text": "Square"
            },
	        {
            "id": "star10",
            "text": "Star 1"
            },
	        {
            "id": "star4",
            "text": "Star 2"
            },
	        {
            "id": "star5",
            "text": "Star 3"
            },
	        {
            "id": "star6",
            "text": "Star 4"
            },
	        {
            "id": "star7",
            "text": "Star 5"
            },
	        {
            "id": "trapezium",
            "text": "Trapezium"
            },
	        {
            "id": "triangleUp",
            "text": "Triangle Up"
            },
	        {
            "id": "triangleDown",
            "text": "Triangle Down"
            },
	        {
            "id": "triangleLeft",
            "text": "Triangle Left"
            },
	        {
            "id": "triangleRight",
            "text": "Triangle Right"
            },
        ];
        return item;
    }
    public getDrawTool(): any {
        var item = [{
            "id": "line",
            "text": "Line Segment"
            },
	        {
            "id": "horizontalLine",
            "text": "Horizontal Line"
            },
	        {
            "id": "verticalLine",
            "text": "Vertical Line"
            },
	        {
            "id": "infiniteLine",
            "text": "Infinite Line"
            },
	        {
            "id": "triangle",
            "text": "Triangle"
            },
	        {
            "id": "rectangle",
            "text": "Rectangle"
            },
	        {
            "id": "ellipse",
            "text": "Ellipse"
            },
	        {
            "id": "horizontalRange",
            "text": "Horizontal Range"
            },
	        {
            "id": "verticalRange",
            "text": "Vertical Range"
            },
	        {
            "id": "trendChannel",
            "text": "Trend Channel"
            },
            {
            "id": "finiteTrendChannel",
            "text": "Finite Trend Channel"
            },
	        {
            "id": "andrewsPitchfork",
            "text": "Andrew's Pitchfork"
            },
	        {
            "id": "fibonacciFan",
            "text": "Fibonacci Fan"
            },
	        {
            "id": "fibonacciArc",
            "text": "Fibonacci Arc"
            },
	        {
            "id": "fibonacciRetracement",
            "text": "Fibonacci Retracement"
            },
	        {
            "id": "fibonacciTimezones",
            "text": "Fibonacci Time Zones"
            },
        ];
        return item;
    }
    public getFontSize(): any {
        var item = [{
            "id": "5",
            "text": "5 px"
            },
            {
            "id": "10",
            "text": "10 px"
            },
            {
            "id": "15",
            "text": "15 px"
            },
            {
            "id": "20",
            "text": "20 px"
            },
            {
            "id": "25",
            "text": "25 px"
            },
            {
            "id": "30",
            "text": "30 px"
            },
            {
            "id": "35",
            "text": "35 px"
            },
        ];
        return item;
    }
    public getThemes(): any {
        var item = [{
            "id": "sageGreen",
            "text": "Dark"
            },
            {
            "id": "classicBlue",
            "text": "Light"
            },
        ];
        return item;
    }
    public getLanguages(): any {
        var item = [{
            "id": "en",
            "text": "English"
            },
            {
            "id": "bn",
            "text": "Bangla"
            },
        ];
        return item;
    }

getDerivativeTypeConverter(product:string) {
    if(product == "EQUITY"){
        product = "EQUITY";
    }else if(product == "OPTSTK"){
        product = "STO";
    }else if(product == "FUTSTK"){
        product = "STF";
    }else if(product == "FUTIDX"){
        product = "IDF";
    }else if(product == "OPTIDX"){
    product = "IDO";
    }else if(product == "FUTCOM"){
        product = "CFT";
    }else if(product == "OPTCOM"){
        product = "COT";
    }
    return product;
}
getProductForMarketWatch(product) {
    if(product == "EQUITY" ||product == "EQUITY MARKET" ){
        product = "EQUITY";
    }else if(product == "OPTSTK"){
        product = "FUTOPT";
    }else if(product == "FUTSTK"){
        product = "FUTOPT";
    }else if(product == "FUTIDX"){
        product = "FUTOPT";
    }else if(product == "OPTIDX"){
    product = "FUTOPT";
    }else if(product == "FUTCOM"){
        product = "COMDERV";
    }else if(product == "OPTCOM"){
        product = "COMDERV";
    }
    return product;
}
exportGridFunction(rows,columns,fileName){
   if (rows.length === 0) {
        console.error('No data available to export');
        return;
    }// Create the header row dynamically based on the keys of the first row object
    let xlsData = '<table>';// Create the header row
    xlsData += '<tr>';
    columns.forEach(col => {
        xlsData += `<th>${col.text}</th>`;
    });
    xlsData += '</tr>';// Create the data rows
    rows.forEach(row => {
        xlsData += '<tr>';
        columns.forEach(col => {
            xlsData += `<td>${row[col.datafield]}</td>`;
        });
        xlsData += '</tr>';
    });xlsData += '</table>';// Create a Blob and download the file as .xls
    const blob = new Blob([xlsData], { type: 'application/vnd.ms-excel' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    //a.download = 'export.xls';
    a.download = fileName + '.xls';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
}
}

